export type TabId =
  | "globalSettings"
  | "membershipSettings"
  | "emailCommunications"
  | "affinityProgramSetup"
  | "governanceGroups"
  | "usersPermissions";

export const globalSettingsSectionIds = [
  "chamberGlobals", "taxSettings", "accountAllocation", "paymentOptions",
  "invoicingOptions", "memberCommunication", "governanceGroups",
  "membershipSettings", "emailCommunications",
] as const;

export type GlobalSettingsSectionId = typeof globalSettingsSectionIds[number];

export type ToggleState = Record<string, boolean>;
